module.exports = __webpack_public_path__ + "static/media/gc-taxi.7196874f.png";